import { useState } from "react";
import { T } from "../../theme";
import { REL } from "../../theme";
import { usePeople } from "../../context/PeopleContext";

export const AGREEMENT_ICONS = ["⚓","🔔","⚖️","🌙","📅","⏰","🍽️","💬","🎯","⭐","🔔","🤝"];

export const INIT_AGREEMENTS = [
  {id:"ag3",icon:"🍽️",title:"Sunday family dinner",   detail:"Every Sunday · 5–8 PM",       color:T.family, person:"Mom",   type:"recurring"},
  {id:"ag4",icon:"📆",title:"Custody rotation",        detail:"Mon–Thu / Fri–Sun alternating",color:T.coparent,person:"Devon",type:"schedule"},
];

const AGREEMENT_TEMPLATES = {
  partner:[
    {icon:"🌙",text:"No overnights on school nights"},
    {icon:"⏰",text:"24h notice for schedule changes"},
    {icon:"⚓",text:"Anchor: every Tuesday evening"},
    {icon:"📅",text:"Max 3 consecutive nights"},
  ],
  family:[
    {icon:"🍽️",text:"Sunday family dinner"},
    {icon:"🏫",text:"School pickup: Mon/Wed/Fri 3pm"},
    {icon:"🎄",text:"Holidays: alternating years"},
    {icon:"📞",text:"Weekly check-in call"},
  ],
  coparent:[
    {icon:"📆",text:"Custody: Mon–Thu / Fri–Sun rotation"},
    {icon:"⏰",text:"48h notice for schedule swaps"},
    {icon:"🏥",text:"Shared: doctor appointments"},
    {icon:"📋",text:"Holiday schedule per agreement"},
  ],
};

export function AgreementModal({editId, agreements, onSave, onClose, defaultPerson=""}) {
  const {people:PEOPLE} = usePeople();
  const existing = editId ? agreements.find(a=>a.id===editId) : null;
  const [draft,setDraft] = useState(existing
    ? {icon:existing.icon,title:existing.title,detail:existing.detail,person:existing.person,type:existing.type,recurrence:existing.recurrence||""}
    : {icon:"⚓",title:"",detail:"",person:defaultPerson,type:"recurring",recurrence:""});
  const [iconPicker,setIconPicker] = useState(false);
  const colorFor = (name) => { const p=PEOPLE.find(x=>x.name===name); return p?REL[p.type].color:T.muted; };
  const previewColor = draft.person ? colorFor(draft.person) : T.bark;
  const typeOptions = [
    {id:"anchor",   label:"Anchor night",icon:"⚓",desc:"Recurring protected time"},
    {id:"recurring",label:"Recurring",   icon:"🔁",desc:"Regular commitment"},
    {id:"schedule", label:"Schedule",    icon:"📅",desc:"Shared calendar rule"},
    {id:"boundary", label:"Boundary",   icon:"⊘", desc:"Personal limit or rule"},
  ];
  const recurrenceOptions = ["Every week","Every 2 weeks","Every month","Custom…"];
  const isEdit = !!editId;
  const canSave = draft.title.trim().length > 0;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(30,16,8,0.45)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
      onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={{width:"100%",maxWidth:480,background:T.surface,borderRadius:20,boxShadow:"0 12px 48px rgba(30,16,8,0.22)",animation:"popIn .2s ease",maxHeight:"92vh",overflowY:"auto",display:"flex",flexDirection:"column"}}>

        <div style={{padding:"20px 24px 0",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
          <h3 style={{fontSize:18,fontFamily:"'Crimson Pro',serif",fontWeight:600,color:T.ink}}>{isEdit?"Edit agreement":"New agreement"}</h3>
          <button onClick={onClose} style={{width:28,height:28,borderRadius:"50%",background:T.mist,border:"none",cursor:"pointer",color:T.muted,fontSize:14}}>✕</button>
        </div>

        {draft.title&&<div style={{margin:"14px 24px 0",padding:"12px 14px",borderRadius:12,background:previewColor+"10",border:`1px solid ${previewColor}30`,display:"flex",alignItems:"center",gap:12}}>
          <div style={{width:36,height:36,borderRadius:9,background:previewColor+"18",border:`1px solid ${previewColor}30`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{draft.icon}</div>
          <div style={{flex:1,minWidth:0}}>
            <p style={{fontSize:13,fontWeight:600,color:T.ink}}>{draft.title}</p>
            {draft.detail&&<p style={{fontSize:11,color:T.muted}}>{draft.detail}</p>}
            {draft.recurrence&&<p style={{fontSize:11,color:previewColor,marginTop:2}}>{draft.recurrence}</p>}
          </div>
          {draft.person&&<span style={{fontSize:11,color:previewColor,background:previewColor+"12",padding:"2px 8px",borderRadius:8,fontWeight:500,flexShrink:0}}>{draft.person}</span>}
        </div>}

        <div style={{padding:"14px 24px 20px",display:"flex",flexDirection:"column",gap:14}}>

          <div style={{display:"flex",gap:10,alignItems:"flex-start"}}>
            <div style={{position:"relative",flexShrink:0}}>
              <button onClick={()=>setIconPicker(v=>!v)} style={{width:44,height:44,borderRadius:11,background:T.mist,border:`1.5px solid ${iconPicker?T.partner:T.edge}`,fontSize:20,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>{draft.icon}</button>
              {iconPicker&&(
                <div style={{position:"absolute",top:"calc(100% + 6px)",left:0,background:T.surface,borderRadius:12,border:`1px solid ${T.edge}`,boxShadow:"0 8px 24px rgba(60,40,20,.14)",padding:10,zIndex:10,display:"grid",gridTemplateColumns:"repeat(6,1fr)",gap:4,width:210}}>
                  {AGREEMENT_ICONS.map(ic=>(
                    <button key={ic} onClick={()=>{setDraft(d=>({...d,icon:ic}));setIconPicker(false);}} style={{width:30,height:30,borderRadius:7,border:"none",cursor:"pointer",background:draft.icon===ic?T.partner+"20":T.mist,fontSize:16,display:"flex",alignItems:"center",justifyContent:"center"}}>{ic}</button>
                  ))}
                </div>
              )}
            </div>
            <div style={{flex:1}}>
              <label style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>Title *</label>
              <input autoFocus value={draft.title} onChange={e=>setDraft(d=>({...d,title:e.target.value}))} placeholder="e.g. Wednesday anchor night" style={{width:"100%",padding:"9px 12px",borderRadius:10,border:`1.5px solid ${draft.title?T.partner+"60":T.edge}`,background:T.mist,fontSize:13,color:T.ink,fontFamily:"'DM Sans',sans-serif",outline:"none",boxSizing:"border-box"}}/>
            </div>
          </div>

          <div>
            <label style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:4}}>Details <span style={{textTransform:"none",letterSpacing:0,color:T.edgeMid}}>(optional)</span></label>
            <input value={draft.detail} onChange={e=>setDraft(d=>({...d,detail:e.target.value}))} placeholder="e.g. 7–10 PM, no phones" style={{width:"100%",padding:"9px 12px",borderRadius:10,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:13,color:T.ink,fontFamily:"'DM Sans',sans-serif",outline:"none",boxSizing:"border-box"}}/>
          </div>

          <div>
            <label style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Recurrence</label>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {recurrenceOptions.map(r=>(
                <button key={r} onClick={()=>setDraft(d=>({...d,recurrence:d.recurrence===r?"":r}))} style={{padding:"5px 11px",borderRadius:16,border:`1.5px solid ${draft.recurrence===r?T.partner+"60":T.edge}`,background:draft.recurrence===r?T.partner+"14":T.mist,color:draft.recurrence===r?T.partner:T.muted,fontSize:11,cursor:"pointer",fontWeight:draft.recurrence===r?600:400}}>{r}</button>
              ))}
            </div>
            {draft.recurrence==="Custom…"&&<input value={""} placeholder="e.g. First Monday of each month" onChange={e=>setDraft(d=>({...d,recurrence:e.target.value}))} style={{width:"100%",marginTop:8,padding:"8px 12px",borderRadius:10,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:12,color:T.ink,fontFamily:"'DM Sans',sans-serif",outline:"none",boxSizing:"border-box"}}/>}
          </div>

          <div>
            <label style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Person <span style={{textTransform:"none",letterSpacing:0,color:T.edgeMid}}>(optional)</span></label>
            <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
              <button onClick={()=>setDraft(d=>({...d,person:""}))} style={{padding:"5px 10px",borderRadius:16,border:`1.5px solid ${!draft.person?T.bark:T.edge}`,background:!draft.person?T.bark:T.mist,color:!draft.person?"white":T.muted,fontSize:11,cursor:"pointer",fontWeight:!draft.person?600:400}}>Anyone</button>
              {PEOPLE.map(person=>{const col=colorFor(person.name);const sel=draft.person===person.name;return(
                <button key={person.id} onClick={()=>setDraft(d=>({...d,person:sel?"":person.name}))} style={{padding:"5px 10px",borderRadius:16,border:`1.5px solid ${sel?col:T.edge}`,background:sel?col+"18":T.mist,color:sel?col:T.muted,fontSize:11,cursor:"pointer",fontWeight:sel?600:400,display:"flex",alignItems:"center",gap:5}}>
                  <span style={{fontSize:11}}>{REL[person.type]?.icon}</span>{person.name}
                </button>
              );})}
            </div>
          </div>

          <div>
            <label style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.07em",display:"block",marginBottom:6}}>Type</label>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
              {typeOptions.map(t=>(
                <button key={t.id} onClick={()=>setDraft(d=>({...d,type:t.id}))} style={{padding:"9px 11px",borderRadius:10,border:`1.5px solid ${draft.type===t.id?T.partner:T.edge}`,background:draft.type===t.id?T.partner+"10":T.mist,cursor:"pointer",textAlign:"left",display:"flex",gap:8,alignItems:"center"}}>
                  <span style={{fontSize:14}}>{t.icon}</span>
                  <div><p style={{fontSize:12,fontWeight:draft.type===t.id?700:400,color:draft.type===t.id?T.ink:T.bark}}>{t.label}</p><p style={{fontSize:11,color:T.muted}}>{t.desc}</p></div>
                </button>
              ))}
            </div>
          </div>

          <div style={{display:"flex",gap:8,paddingTop:4}}>
            <button onClick={onClose} style={{flex:1,padding:11,borderRadius:11,background:"transparent",border:`1px solid ${T.edge}`,color:T.muted,fontSize:13,cursor:"pointer"}}>Cancel</button>
            <button onClick={()=>canSave&&onSave(draft)} style={{flex:2,padding:11,borderRadius:11,background:canSave?T.bark:T.edgeMid,border:"none",color:"white",fontSize:13,fontWeight:600,cursor:canSave?"pointer":"default",transition:"background .15s"}}>
              {isEdit?"Save changes":"Add agreement →"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function AgreementsTab() {
  const {people:PEOPLE,agreements,saveAgreement,deleteAgreement} = usePeople();
  const [modal,setModal] = useState(null);
  const [toast,setToast] = useState(null);
  const showToast = (m) => { setToast(m); setTimeout(()=>setToast(null),2200); };

  const colorFor = (name) => { const p=PEOPLE.find(x=>x.name===name); return p?REL[p.type].color:T.muted; };

  const addFromTemplate = async (tmpl,type) => {
    await saveAgreement({icon:tmpl.icon,title:tmpl.text,detail:"Template — tap to customize",color:REL[type].color,person:"",type:"recurring",recurrence:""});
    showToast("Added from template ✓");
  };

  const handleSave = async (draft) => {
    const color = draft.person ? colorFor(draft.person) : T.bark;
    const ag = {icon:draft.icon,title:draft.title.trim(),detail:draft.detail.trim()||"No details",color,person:draft.person,type:draft.type,recurrence:draft.recurrence||""};
    if(modal!=="new") ag.id = modal;
    await saveAgreement(ag);
    showToast(modal==="new"?"Agreement added ✓":"Saved ✓");
    setModal(null);
  };

  const removeAgreement = async (id) => { await deleteAgreement(id); showToast("Removed"); };

  const typeOptions = [
    {id:"anchor",   label:"Anchor night",icon:"⚓"},
    {id:"recurring",label:"Recurring",   icon:"🔁"},
    {id:"schedule", label:"Schedule",    icon:"📅"},
    {id:"boundary", label:"Boundary",   icon:"⊘"},
  ];

  return (<div style={{maxWidth:900,margin:"0 auto",position:"relative"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
      <h2 style={{fontSize:22,fontFamily:"'Crimson Pro',serif",fontWeight:300}}>Agreements</h2>
      <button onClick={()=>setModal("new")} style={{display:"flex",alignItems:"center",gap:6,padding:"7px 14px",borderRadius:10,background:T.bark,border:"none",color:"white",fontSize:12,fontWeight:600,cursor:"pointer"}}>
        + Custom
      </button>
    </div>

    {agreements.length>0&&(
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:10,marginBottom:28}}>
        {agreements.map(a=>(
          <div key={a.id} style={{background:T.surface,borderRadius:13,padding:16,border:`1px solid ${a.color}30`,boxShadow:"0 2px 8px rgba(60,40,20,.05)",position:"relative"}}>
            <div style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:8}}>
              <div style={{width:34,height:34,borderRadius:9,background:a.color+"14",border:`1px solid ${a.color}25`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0}}>{a.icon}</div>
              <div style={{flex:1,minWidth:0}}>
                <p style={{fontSize:13,fontWeight:600,color:T.ink,marginBottom:2}}>{a.title}</p>
                <p style={{fontSize:11,color:T.muted,lineHeight:1.4}}>{a.detail}</p>
                {a.recurrence&&<p style={{fontSize:11,color:a.color,marginTop:2}}>{a.recurrence}</p>}
              </div>
              <div style={{display:"flex",gap:4,flexShrink:0}}>
                <button onClick={()=>setModal(a.id)} title="Edit" style={{width:22,height:22,borderRadius:6,background:T.mist,border:`1px solid ${T.edge}`,cursor:"pointer",color:T.muted,fontSize:11,display:"flex",alignItems:"center",justifyContent:"center"}}>✎</button>
                <button onClick={()=>removeAgreement(a.id)} title="Remove" style={{width:22,height:22,borderRadius:6,background:"transparent",border:`1px solid ${T.edge}`,cursor:"pointer",color:T.muted,fontSize:11,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
              </div>
            </div>
            <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
              {a.person&&<span style={{fontSize:11,color:a.color,background:a.color+"12",padding:"2px 7px",borderRadius:8,border:`1px solid ${a.color}25`,fontWeight:500}}>{a.person}</span>}
              <span style={{fontSize:11,color:T.muted,background:T.mist,padding:"2px 7px",borderRadius:8}}>{typeOptions.find(t=>t.id===a.type)?.label||a.type}</span>
            </div>
          </div>
        ))}
      </div>
    )}

    <div style={{marginBottom:8}}>
      <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:14}}>Templates — click to add</p>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:16}}>
        {Object.entries(REL).map(([key,cfg])=>{
          const templates=AGREEMENT_TEMPLATES[key]; if(!templates) return null;
          return(<div key={key} style={{background:T.surface,borderRadius:16,padding:20,border:`1px solid ${T.edge}`,boxShadow:"0 2px 12px rgba(60,40,20,0.05)"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:14}}>
              <span style={{fontSize:18,color:cfg.color}}>{cfg.icon}</span>
              <h3 style={{fontSize:14,fontWeight:600,color:T.ink}}>{cfg.label} templates</h3>
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:7}}>
              {templates.map((t,i)=>(
                <div key={i} onClick={()=>addFromTemplate(t,key)} style={{display:"flex",alignItems:"center",gap:9,padding:"8px 10px",borderRadius:9,background:T.mist,border:`1px dashed ${T.edge}`,cursor:"pointer"}}>
                  <span style={{fontSize:14}}>{t.icon}</span>
                  <span style={{fontSize:12,color:T.bark,flex:1}}>{t.text}</span>
                  <span style={{fontSize:11,color:cfg.color,fontWeight:600}}>+ Add</span>
                </div>
              ))}
            </div>
          </div>);
        })}
      </div>
    </div>

    {modal&&<AgreementModal editId={modal==="new"?null:modal} agreements={agreements} onSave={handleSave} onClose={()=>setModal(null)}/>}
    {toast&&<div style={{position:"fixed",bottom:24,left:"50%",transform:"translateX(-50%)",background:T.ink,color:T.parchment,padding:"9px 20px",borderRadius:20,fontSize:13,fontWeight:500,zIndex:300,animation:"fadeUp .2s ease",whiteSpace:"nowrap"}}>{toast}</div>}
  </div>);
}

export const PERSON_NOTES = {
  1:"Great communicator. Prefers texting before calling. Loves Italian food.",
  2:"Long distance — video call before visits. Kid-friendly scheduling always first.",
  3:"No overnights by mutual agreement. Flexible on daytimes.",
  4:"Traveling frequently. Give 1 week notice for nesting weeks.",
  5:"Sunday dinners are sacred. Always brings dessert.",
  6:"Busy with work. Best reached on weekends.",
  7:"Weekly coffee Fridays. Running buddy on Saturdays.",
  8:"Old friend — easy to pick up where we left off despite long gaps.",
  9:"Shared custody of Luna (🐕). Handoffs at the usual spot.",
};

export const PERSON_UPCOMING = {
  1:[{label:"Tonight",sub:"Dinner + staying in",color:"partner"}],
  2:[{label:"Sat Mar 1",sub:"Visit requested",color:"partner"}],
  3:[{label:"Thu Feb 20",sub:"Date night",color:"partner"}],
  4:[{label:"Mar 7",sub:"Nesting week starts",color:"partner"}],
  5:[{label:"Sun Feb 22",sub:"Sunday dinner",color:"family"}],
  6:[{label:"Mar 15",sub:"Catch-up call",color:"family"}],
  7:[{label:"Fri Feb 21",sub:"Friday coffee",color:"friend"}],
  8:[{label:"Mar 20",sub:"Long-overdue catch-up",color:"friend"}],
  9:[{label:"Tomorrow",sub:"Handoff — usual spot",color:"coparent"},{label:"Fri Feb 21",sub:"Weekend exchange",color:"coparent"}],
};

export const PRIVACY_OPTS = [
  {id:"full",     label:"Full details",  desc:"Exact times, titles & notes",  icon:"📋"},
  {id:"avail",    label:"Availability",  desc:"Free / busy windows only",      icon:"📊"},
  {id:"busy",     label:"Busy blocks",   desc:"Only when unavailable",         icon:"🔶"},
  {id:"hidden",   label:"Hidden",        desc:"No calendar info shared",       icon:"🚫"},
];
export const PL = PRIVACY_OPTS.map(o=>({id:o.id,icon:o.icon,l:o.label.split(" ")[0]}));

export function PersonAgreements({p, c}) {
  const {agreements,saveAgreement,deleteAgreement} = usePeople();
  const [modal,setModal] = useState(null);
  const [toast,setToast] = useState(null);
  const showToast = (m) => { setToast(m); setTimeout(()=>setToast(null),2000); };

  const myAgreements = agreements.filter(a=>a.person===p.name);
  const typeOptions = [
    {id:"anchor",   label:"Anchor night", icon:"⚓"},
    {id:"recurring",label:"Recurring",    icon:"🔁"},
    {id:"schedule", label:"Schedule",     icon:"📅"},
    {id:"boundary", label:"Boundary",     icon:"⊘"},
  ];

  const handleSave = async (draft) => {
    const ag = {icon:draft.icon,title:draft.title.trim(),detail:draft.detail.trim()||"",color:c,person:p.name,type:draft.type,recurrence:draft.recurrence||""};
    if(modal!=="new") ag.id = modal;
    await saveAgreement(ag);
    showToast(modal==="new"?"Agreement added ✓":"Saved ✓");
    setModal(null);
  };
  const remove = async (id) => { await deleteAgreement(id); showToast("Removed"); };

  const templates = (AGREEMENT_TEMPLATES[p.type]||[]);

  return(<div style={{animation:"fadeUp .2s ease"}}>
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em"}}>Active agreements</p>
      <button onClick={()=>setModal("new")} style={{padding:"4px 11px",borderRadius:9,background:c,border:"none",color:"white",fontSize:11,fontWeight:600,cursor:"pointer"}}>+ New</button>
    </div>

    {myAgreements.length>0
      ? myAgreements.map(a=>(
        <div key={a.id} style={{display:"flex",alignItems:"flex-start",gap:12,padding:"12px 14px",borderRadius:11,background:T.surface,border:`1px solid ${c}25`,marginBottom:8}}>
          <div style={{width:32,height:32,borderRadius:8,background:c+"14",border:`1px solid ${c}25`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:15,flexShrink:0}}>{a.icon}</div>
          <div style={{flex:1,minWidth:0}}>
            <p style={{fontSize:13,fontWeight:600,color:T.ink,marginBottom:2}}>{a.title}</p>
            {a.detail&&<p style={{fontSize:11,color:T.muted,lineHeight:1.4}}>{a.detail}</p>}
            {a.recurrence&&<p style={{fontSize:11,color:c,marginTop:2}}>{a.recurrence}</p>}
            <span style={{fontSize:11,color:c,background:c+"12",padding:"1px 7px",borderRadius:6,marginTop:4,display:"inline-block"}}>{typeOptions.find(t=>t.id===a.type)?.label||a.type}</span>
          </div>
          <div style={{display:"flex",gap:4,flexShrink:0}}>
            <button onClick={()=>setModal(a.id)} style={{width:22,height:22,borderRadius:6,background:T.mist,border:`1px solid ${T.edge}`,cursor:"pointer",color:T.muted,fontSize:11,display:"flex",alignItems:"center",justifyContent:"center"}}>✎</button>
            <button onClick={()=>remove(a.id)} style={{width:22,height:22,borderRadius:6,background:"transparent",border:`1px solid ${T.edge}`,cursor:"pointer",color:T.muted,fontSize:11,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
          </div>
        </div>
      ))
      : <div style={{textAlign:"center",padding:"24px 0",color:T.muted,marginBottom:8}}>
          <p style={{fontSize:28,marginBottom:6}}>📝</p>
          <p style={{fontSize:13}}>No agreements yet</p>
        </div>
    }

    {templates.length>0&&(<>
      <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8,marginTop:4}}>Templates</p>
      {templates.map((t,i)=>(
        <div key={i} onClick={()=>{saveAgreement({icon:t.icon,title:t.text,detail:"",color:c,person:p.name,type:"recurring",recurrence:""});showToast("Added ✓");}}
          style={{display:"flex",alignItems:"center",gap:9,padding:"8px 10px",borderRadius:9,background:T.mist,border:`1px dashed ${T.edge}`,cursor:"pointer",marginBottom:6}}>
          <span style={{fontSize:13}}>{t.icon}</span>
          <span style={{fontSize:12,color:T.bark,flex:1}}>{t.text}</span>
          <span style={{fontSize:11,color:c,fontWeight:600}}>+ Add</span>
        </div>
      ))}
    </>)}

    {modal&&<AgreementModal
      editId={modal==="new"?null:modal}
      agreements={agreements}
      defaultPerson={p.name}
      onSave={handleSave}
      onClose={()=>setModal(null)}
    />}
    {toast&&<div style={{position:"fixed",bottom:24,left:"50%",transform:"translateX(-50%)",background:T.ink,color:T.parchment,padding:"9px 20px",borderRadius:20,fontSize:13,fontWeight:500,zIndex:300,animation:"fadeUp .2s ease",whiteSpace:"nowrap"}}>{toast}</div>}
  </div>);
}
